import { gql } from '@apollo/client';

export const fetchPaymentMethodsForTransactionAccount = gql`
  query fetchPaymentMethodsOfTransactionAccountForDetailPage($id: ID!, $fetchAch: Boolean = false) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availableInvoiceGroups {
        nodes {
          id
          defaultPaymentMethod {
            id
            type
            paymentIssue
          }
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
            totalCreditLimit
            paymentMethod
          }
          ... on PayPal {
            payPal {
              name
              email
            }
          }
          ... on Ach {
            ach @include(if: $fetchAch) {
              bankName
              last4
            }
          }
        }
      }
      customerBalances {
        usd
        jpy
      }
      billToParty {
        country
        taxExempt
      }
      billToPartyPricingEligibilty
      billingAccountsList {
        availableCreditLimit
        currency
        status
        nodes {
          pendingInvoiceRequestsTotal
          transactionAccountId
          creditOutstanding
        }
      }
    }
  }
`;
